import { Container } from './TagStyles';
import { COLORS } from '@/styles/colorTheme';
import { cn } from '@/lib/utils';

interface TagProps {
  children?: React.ReactNode;
  variant?: 'topic' | 'company';
  width?: string;
  uppercase?: boolean;
  className?: string;
}

const Tag = ({ children, variant, width, uppercase = true, className }: TagProps) => {
  let background = 'rgba(25, 118, 210, 0.01)';
  let borderColor = 'rgba(25, 118, 210, 0.50)';
  let color = 'rgba(25, 118, 210, 1)';

  if (variant === 'topic') {
    background = 'rgba(25, 118, 210, 0.01)';
    borderColor = 'rgba(25, 118, 210, 0.50)';
    color = 'rgba(25, 118, 210, 1)';
  }

  if (variant === 'company') {
    background = '#fff';
    borderColor = COLORS.Text100;
    color = COLORS.Text300;
  }

  return (
    <Container
      background={background}
      borderColor={borderColor}
      width={width}
      className={cn('py-1 px-2', className)}
    >
      <div className={cn(uppercase ? 'uppercase' : '')} style={{ color: color }}>
        {children}
      </div>
    </Container>
  );
};

export default Tag;
